import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {withRouter} from 'react-router';

import Go from './Go';
import LoadingIndicator from './LoadingIndicator';
import {withI18n} from 'spa/Components/Context';
import decorate from 'spa/lib/decorate';


@inject('store')
@observer
@withI18n
class SessionSplit extends React.Component {
  static propTypes = {
    store: PropTypes.any,
    loggedIn: PropTypes.func,
    loggedOut: PropTypes.func,
    children: PropTypes.any,
  };

  UNSAFE_componentWillMount() {
    const {isLoggedIn, maybeLoggedIn, isLoading} = this.props.store.session;
    if (!isLoading && !isLoggedIn && maybeLoggedIn) {
      this.props.store.session.load();
    }
  }

  render() {
    const {isLoggedIn, maybeLoggedIn} = this.props.store.session;

    if (!isLoggedIn && maybeLoggedIn) {
      if (this.props.store.session.isLoading) {
        return <LoadingIndicator style={{color: '#333', fontSize: 10}} />;
      } else if (this.props.store.session.error) {
        return <div style={{fontSize: 30}}>Whoops!</div>;
      }

      // wtf?
      return <div style={{fontSize: 30}}>💩</div>; //eslint-disable-line jsx-a11y/accessible-emoji
    } else if (isLoggedIn && this.props.loggedIn) {
      return React.Children.only(this.props.loggedIn(this.props.store.session.user));
    } else if (!isLoggedIn && this.props.loggedOut) {
      return React.Children.only(this.props.loggedOut());
    }

    return this.props.children ? React.Children.only(this.props.children) : null;
  }
}

export default SessionSplit;

export function withUser(Component) {
  const fn = props => (
    <SessionSplit
      loggedIn={user => <Component user={user} {...props} />}
    />
  );
  fn.displayName = `withUser(${Component.displayName || Component.name})`;
  return fn;
}

export function requireLogin(Component) {
  const fn = decorate([withRouter, withI18n], ({router, location, ...rest}, {i18n}) => {
    const returnUrl = location && router.createHref({
      ...location,
      query: {
        ...location.query,
        message: undefined,
      },
    });

    return (
      <SessionSplit
        loggedIn={user => <Component user={user} location={location} {...rest} />}
        loggedOut={() => (
          location &&
          location.pathname &&
          location.pathname.indexOf('logout') === -1 &&
          location.pathname.indexOf('login') === -1 ? (
              <Go
                to={{
                  pathname: `/${i18n.lc}/login`,
                  query: {
                    returnUrl,
                  },
                }}
              />
            ) : (
              <Component location={location} {...rest} />
            )
        )}
      />
    );
  });
  fn.displayName = `requireLogin(${Component.displayName || Component.name})`;
  return fn;
}



// WEBPACK FOOTER //
// ./spa/Components/SessionSplit.jsx